import "./GCodeGenerateButton.css"
import {Button} from "primereact/button";
import React from "react";
import {urls} from "../../ApiUtils";
import {fileEditorStore} from "../../stores/FileEditorStore";
import {observer} from "mobx-react-lite";
import {GCodeParameters, gCodeParametersStore} from "../../stores/GCodeParametersStore";
import {GCodeParametersToStringSerializer, GCodeSettingBuilder} from "../../util/GCodeSettingBuilder";
import {HistorySyncState, historySyncStore} from "../../stores/HistorySyncStore";

const ANCHOR_ELEMENT_TAG = "a";

function GCodeGenerateButton() {
    function handleGCodeGenerate(e: any) {
        e.currentTarget.blur();
        if (!fileEditorStore.isActive) {
            console.warn("no file selected")
            return;
        }
        const fileName: string = fileEditorStore.selectedFileName
        const parameters = createGCodeGenerateParams()
        const generateUrl: string = urls.apiV1.gcode.generate(fileName, parameters).url
        let link: HTMLAnchorElement
        let url: string
        fetch(generateUrl)
            .then((response) => response.blob())
            .then((blob) => {
                url = window.URL.createObjectURL(new Blob([blob]));
                link = document.createElement(ANCHOR_ELEMENT_TAG);
                link.href = url;
                const extension = gCodeParametersStore.getParameters().useSeparateFiles ? "zip" : "cnc";
                link.download = `${fileName}.${extension}`;
                document.body.appendChild(link);
                link.click();
            })
            .catch((error) => {
                console.error("Error fetching the file:", error);
            })
            .finally(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            });
    }

    function createGCodeGenerateParams(): string {
        let parameters: GCodeParameters = gCodeParametersStore.getParameters();

        return GCodeSettingBuilder.instance()
            .withParameters(parameters)
            .build(
                new GCodeParametersToStringSerializer()
            )
    }

    return <>
        <div className={"g-code-generate-button"}>
            <span>G Code</span>
            <Button
                onClick={handleGCodeGenerate}
                disabled={historySyncStore.getState() != HistorySyncState.SYNCED}>
                {historySyncStore.getState() == HistorySyncState.SYNCED ? <>Generate</> : <>Sync...</>}
            </Button>
        </div>
    </>
}

export default observer(GCodeGenerateButton)